import { render, staticRenderFns } from "./OperaForcedReturnWindow.vue?vue&type=template&id=1370b74b&scoped=true&"
import script from "./OperaForcedReturnWindow.vue?vue&type=script&lang=js&"
export * from "./OperaForcedReturnWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaForcedReturnWindow.vue?vue&type=style&index=0&id=1370b74b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370b74b",
  null
  
)

export default component.exports